import { Core } from "@faire/design-tokens";
import { Avatar } from "@faire/web--source/slate/deprecated/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import {
  NoTranslate,
  StrictLocalMsg,
} from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackSeoSuppliersPageMostPopularCarouselBrandClick } from "@faire/web-api--source/events/seo/click/suppliersPageMostPopularCarouselBrand";
import { trackSeoSuppliersPageMostPopularCarouselProductTileClick } from "@faire/web-api--source/events/seo/click/suppliersPageMostPopularCarouselProductTile";
import { IBrandReviewTile } from "@faire/web-api--source/indigofair/data/IBrandReviewTile";
import React from "react";
import styled from "styled-components";

import { brandPage } from "@faire/retailer/paths";
import { BrandReview } from "@faire/retailer/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandReview";
import { BrandReviewTileImages } from "@faire/retailer/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandReviewTileImages";

interface IProps {
  item: IBrandReviewTile;
  onClick?: (token: string) => void;
}

export const BrandReviewWithCommentTile: React.FC<IProps> = ({
  item,
  onClick,
}) => {
  const { brand_name, brand_image, brand_token, products, order_count } = item;
  return (
    <BorderColumn>
      <BrandReviewTileImages
        brandName={brand_name}
        products={products}
        brandToken={brand_token}
        onProductClick={(productToken) => {
          trackSeoSuppliersPageMostPopularCarouselProductTileClick(
            productToken
          );
          onClick?.(productToken);
        }}
      />
      <Link
        to={brandPage(brand_token ?? "")}
        onClick={() => {
          trackSeoSuppliersPageMostPopularCarouselBrandClick(brand_token ?? "");
          onClick?.(brand_token ?? "");
        }}
      >
        <Content>
          <CenterItemsRow>
            <Avatar size="small" image={brand_image} altTag={brand_name} />
            <Spacer width="2x" />
            <Column>
              <Typography maxLines={1} variant="paragraphSansMedium">
                <NoTranslate>{brand_name}</NoTranslate>
              </Typography>
              {order_count ? (
                <Typography maxLines={1} color={Core.text.subdued}>
                  <StrictLocalMsg
                    defaultMessage="{orderCountNumber, plural, one{# order this month} other{# orders this month}}"
                    description={{
                      text: "on most popular brand tile, show how many orders were placed this month",
                      img: "https://cdn.faire.com/fastly/52c601eb05f821bb206a977770e0f1dfda4b223c9f02149fd7bf184f18cbf7d4.png",
                    }}
                    values={{ orderCountNumber: order_count }}
                  />
                </Typography>
              ) : null}
            </Column>
          </CenterItemsRow>

          <BrandReview item={item} />
        </Content>
      </Link>
    </BorderColumn>
  );
};

const Content = styled(Column)`
  padding: ${getSpacing("2x")};
`;

const CenterItemsRow = styled(Row).attrs({ align: "center" })``;

const BorderColumn = styled(Column)`
  border: 1px solid ${Core.border.muted};
  height: 100%;
`;
